import React from 'react';
import './Loader.css';

const Loader = () => (
  <>
    <div className="box">
      <div className="shadow" />
      <div className="gravity">
        <div className="ball" />
      </div>
    </div>
    <h2>Loading Leagues Standings</h2>
  </>
);

export default Loader;
